<template>
  <div class="forum-stats">
    <h3 class="typo-headline-6">Estadísticas del Foro</h3>
    <div v-if="loading" class="loading-stats typo-body-2">
      Cargando estadísticas...
    </div>
    <div v-else-if="error" class="error-stats typo-body-2">
      Error al cargar estadísticas
    </div>
    <div v-else class="stats-content">
      <!-- <div class="stat-item">
        <span class="stat-label">Usuarios activos:</span>
        <span class="stat-value">{{ stats.activeUsers }}</span>
      </div> -->
      <div class="stat-item">
        <span class="stat-label">Hilos totales:</span>
        <span class="stat-value">{{ stats.totalThreads }}</span>
      </div>
      <!-- <div class="stat-item">
        <span class="stat-label">Comentarios hoy:</span>
        <span class="stat-value">{{ stats.commentsToday }}</span>
      </div> -->
      <div class="stat-item">
        <span class="stat-label">Usuarios registrados:</span>
        <span class="stat-value">{{ stats.registeredUsers }}</span>
      </div>
      <!-- <div class="stat-item">
        <span class="stat-label">Último usuario:</span>
        <span class="stat-value">{{ stats.newestUser }}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';

export default {
  name: 'ForumStatsContainer',
  data() {
    return {
      stats: {
        //activeUsers: 0,
        totalThreads: 0,
        //commentsToday: 0,
        registeredUsers: 0
        //newestUser: ''
      },
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchForumStats();
  },
  methods: {
    fetchForumStats() {
      forumApi
        .get('/forum/api/forum-stats')
        .then(response => {
          this.stats = response.data;
        })
        .catch(err => {
          console.error('Error fetching forum stats:', err);
          this.error = 'Error al cargar estadísticas';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.forum-stats {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 15px;
  color: var(--color-text-primary);
}

.forum-stats h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.stat-label {
  color: var(--color-text-secondary);
}

.stat-value {
  font-weight: 500;
}

.loading-stats,
.error-stats {
  text-align: center;
  padding: 10px 0;
}

.error-stats {
  color: #f44336;
}
</style> 